
































































import Vue from 'vue';
import { BRow, BCol, VBTooltip } from 'bootstrap-vue';

import ZenButton from '@reciprocity/button';

export default Vue.extend({
  name: 'HeaderInfo',
  components: {
    BCol,
    BRow,
    ZenButton,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  data() {
    const toggledHelp = localStorage.getItem('previouslyDismissedScopingHelp') === 'true';

    return {
      helpVisible: !toggledHelp,
      steps: [
        {
          icon: 'folder-open-o',
          title: 'Program',
          description:
            'Programs are typically standardized, industry-wide compliance initiatives issued by authoritative sources.',
        },
        {
          icon: 'files-o',
          title: 'Standards',
          description: 'Standards are generally regulatory publications based on authoritative source documents.',
        },
        {
          icon: 'file-text-o',
          title: 'Sections',
          description: 'Sections are actual portions of regulatory publications which group objectives.',
        },
        {
          icon: 'bullseye',
          title: 'Objectives',
          description: 'Objectives are individual compliance requirements that must be met by your organization.',
        },
        {
          icon: 'flag-o',
          title: 'Controls',
          description: 'Controls are the implementation details of how your organization satisfies objectives.',
        },
      ],
    };
  },
  methods: {
    toggleHelp() {
      // We don't save the last set state, we remember if user ever tried to
      // dismiss help and if they did, we don't show it next time.
      localStorage.setItem('previouslyDismissedScopingHelp', 'true');
      this.helpVisible = !this.helpVisible;
    },
  },
});
